var map = {
	"./isabel_steva_colita.jpg": 9356,
	"./isabel_steva_colita.svg": 4810,
	"./joan_baixas.jpg": 5831,
	"./joan_baixas.svg": 2939,
	"./joan_punyet_miro.jpg": 8353,
	"./joan_punyet_miro.svg": 8555,
	"./rosa_maria_malet.jpg": 8152,
	"./rosa_maria_malet.svg": 4330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8497;